import * as Yup from 'yup';
import { isFuture } from 'date-fns';

const accidentInfoSchema = Yup.object().shape({
  contract: Yup.object()
    .nullable()
    .required('validationErrors.isRequired'),
  damageAmount: Yup.number()
    .nullable()
    .typeError('validationErrors.onlyNumber')
    .max(200000000, 'validationErrors.maxNumber')
    .test('isZero', 'validationErrors.isRequired', (v) => v !== 0)
    .required('validationErrors.isRequired'),
  currency: Yup.object()
    .nullable()
    .required('validationErrors.isRequired'),
  accidentInformation: Yup.string()
    .nullable()
    .max(1000, 'validationErrors.maxNumber')
    .isCorrectLanguage(),
  accidentDate: Yup.date()
    .nullable()
    .test('accidentDate', 'validationErrors.accDateCantBeFuture', (value) => !isFuture(value))
    .when(
      'startDate',
      (startDate, schem) => startDate && schem.min(startDate, 'validationErrors.notStartedPolicy'),
    )
    .when(
      'endDate',
      (endDate, schem) => endDate && schem.max(endDate, 'validationErrors.expiredPolicy'),
    )
    .required('validationErrors.isRequired'),
});

export default accidentInfoSchema;
